export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';

export class Login {
  readonly type = LOGIN;
  readonly payload: string;

  constructor(accessToken: string) {
    this.payload = accessToken;
  }
}

export class Logout {
  readonly type = LOGOUT;
}

export class RefreshToken {
  readonly type = REFRESH_TOKEN;
  readonly payload: string;

  constructor(accessToken: string) {
    this.payload = accessToken;
  }
}

export type Action = Login | Logout | RefreshToken;
